import React, {useCallback, useEffect, useState} from 'react';
import useSWR, {useSWRConfig} from "swr";
import './App.css';
import {
  OAuthProvidersTypes,
  OneTapPositions,
  SDKProductTypes,
  Stytch,
  useStytch,
  useStytchSession
} from "@stytch/stytch-react";

import {useNavigate, useLocation} from 'react-router-dom';

function LoginCallbackPage() {
  const stytch = useStytch();
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const token = params.get('token');
    const type = params.get('type');

    if (!token || !type) {
      navigate('/dashboard');
      return;
    }

    const authPromise = type === 'oauth' ?
      stytch.oauth.authenticate(token, {session_duration_minutes: 60}) :
      stytch.magicLinks.authenticate(token, {session_duration_minutes: 60});

    authPromise.finally(() => navigate('/dashboard'));
  }, [stytch, location, navigate]);
  return (
    <div className="Login-Container">
      <h1>Loading...</h1>
    </div>
  )
}

function LoginPage() {
  return (
    <div className="Login-Container">
      <div className="Login-Border">
        <Stytch
          loginOrSignupView={{
            products: [SDKProductTypes.emailMagicLinks],
            emailMagicLinksOptions: {
              loginRedirectURL: window.location.protocol + '//' + window.location.host + '/callback?type=eml',
              signupRedirectURL: window.location.protocol + '//' + window.location.host + '/callback?type=eml',
            },
          }}/>
      </div>
    </div>
  )
}

// const get = url => fetch(url, {
//   credentials: 'same-origin'
// })



const fetcher = (url) => fetch(url, {credentials: 'same-origin'}).then((res) => res.json());

function SelectPageName() {
  const {mutate} = useSWRConfig();

  const onSubmitSlug = async (event) => {
    event.preventDefault();
    const slug = new FormData(event.target).get('slug');
    await fetch("/api/slug", {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({slug}),
    });
    mutate("/api/slug");
  }

  return (
    <form onSubmit={onSubmitSlug}>
      <h2>
        Pick where you would like your page to live
      </h2>
      <input name="slug" type="text" placeholder="my_cool_site"/>
      <button type="submit">Save</button>
    </form>
  )
}

function Dashboard() {
  const stytch = useStytch();
  const {mutate} = useSWRConfig();
  const logout = useCallback(() => stytch.session.revoke(), [stytch]);

  const {data: slugData} = useSWR("/api/slug", fetcher);
  const {data: pageData} = useSWR("/api/config", fetcher);

  if (!slugData || !pageData) {
    return null;
  }

  if (slugData.slug === null) {
    return (
      <div className="Login-Container">
        <SelectPageName/>
      </div>
    )
  }

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    const data = {
      N_ITEMS: formData.get('N_ITEMS'),
      BG_COLOR: formData.get('BG_COLOR'),
      FONT_COLOR: formData.get('FONT_COLOR'),
      IMAGE_URLS: formData.get('IMAGE_URLS').split('\n').map(url => url.trim()),
      COPY: formData.get('COPY').split('\n').map(line => {
        const tokens = line.split(' ');
        return [tokens[0], tokens.slice(1).join(' ')]
      })
    }
    await fetch("/api/config", {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    mutate("/api/config");
  }


  const onDeletePage = async (event) => {
    event.preventDefault();
    await fetch("/api/slug", {method: 'DELETE',});
    mutate("/api/slug");
  }

  return (
    <div className="Login-Container">
      <form onSubmit={onSubmit}>
        <h3>
          Editing: &nbsp;
          <a href={`/pages/${slugData.slug}`}>{slugData.slug}</a>
        </h3>

        <label htmlFor="N_ITEMS">Number of items:</label>
        <input name="N_ITEMS" defaultValue={pageData.N_ITEMS} type="number" min="0" placeholder="3"/>

        <label htmlFor="BG_COLOR">Background Color:</label>
        <input name="BG_COLOR" defaultValue={pageData.BG_COLOR} type="text" placeholder="rgb(247, 244, 234)"/>

        <label htmlFor="FONT_COLOR">Font Color:</label>
        <input name="FONT_COLOR" defaultValue={pageData.FONT_COLOR} type="text" placeholder="rgb(31, 30, 19)"/>

        <label htmlFor="IMAGE_URLS">Image URLs:</label>
        <textarea rows={6} defaultValue={pageData.IMAGE_URLS.join('\n')} name="IMAGE_URLS"
                  placeholder="https://example.com&#13;https://example.net"/>

        <label htmlFor="COPY">Page Copy:</label>
        <textarea rows={6} defaultValue={pageData.COPY.map(line => line.join(' ')).join('\n')} name="COPY"
                  placeholder="h2 Build a website with&#13;h2 Cloudflare pages"/>

        <button type="submit">Save</button>
        <button type="button" onClick={onDeletePage}>Delete Page</button>
        <button type="button" onClick={logout}>Log out</button>
      </form>
    </div>
  )
}

function App() {
  const session = useStytchSession();
  const location = useLocation();

  if (session) {
    return <Dashboard/>
  }

  if (location.pathname === '/callback') {
    return <LoginCallbackPage/>
  }

  return <LoginPage/>
}

export default App;
